import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Lartësia e faqes ndryshon me çdo route — trigger-at duhet të rillogariten.
    ScrollTrigger.refresh();
  }, [pathname]);

  return null;
}
